import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { MRT_ColumnFiltersState, MRT_SortingState } from "mantine-react-table";

interface DownloadUnclaimedMoneyRequest {
  token: string;
  sorting?: MRT_SortingState;
  columnFilters?: MRT_ColumnFiltersState;
}

const downloadUnclaimedMoneyCsv = async ({
  token,
  sorting,
  columnFilters,
}: DownloadUnclaimedMoneyRequest) => {
  try {
    const params: Record<string, any> = {};

    if (sorting && sorting.length > 0) {
      params.sortBy = JSON.stringify({
        field: sorting[0].id,
        order: sorting[0].desc ? "desc" : "asc",
      });
    }

    if (columnFilters && columnFilters.length > 0) {
      params.filter = JSON.stringify(
        columnFilters.map((filter) => ({
          id: filter.id,
          value: filter.value,
        })),
      );
    }

    const response = await axios.get(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/download-unclaimed-money-csv`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params,
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default downloadUnclaimedMoneyCsv;
